export default __webpack_public_path__ + "static/media/Todo.1c21bc60.svg";